export default {"src":"/_next/static/media/lines.2d75acf0.svg","height":529,"width":1856,"blurWidth":0,"blurHeight":0};